import { Personne} from './personne';

export class Article {
    //id: string;
    num: string;
    type: string;
    marque: string;
    modele: string;
    taille: string;
    couleur: string;
    fraisDepot: string;
    prixVente: string;
    // prixVenteInit: string;
    // loginModifPrix: string;
    // commentaireChgtPrix: string;
    vendeur: Personne;
    dateDepot: Date;
    numDepot: string;
    // typePaiemDepot: string;
    // loginDepot: string;
    // dateAchat: DateJson;
    acheteur: Personne;
    // numFactue: string;
    // vendu: boolean;
    // typePaiemAchat: string;
    // loginAchat: string;
    // dateRestitution: DateJson;
    // numRestitution: string;
    // payerRestitution: boolean;
    // loginRestitution: string;
    // ctrlReception: boolean;
    // loginControleReception: string;
    // dateCtrlReception: DateJson;
    // ctrlExpedition: boolean;
    // loginCtrlExpedition: string;
    // dateCtrlExpedition: DateJson;

  constructor() {
  }
}